// extracted by mini-css-extract-plugin
export default {"preview":"style_preview__FmEkA","img":"style_img__7WK7S","model":"style_model__bTPKm","note":"style_note__y7xvB","year":"style_year__abFZB"};